let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("b4NO6")).then(() => parcelRequire('gPFiy'));